// extracted by mini-css-extract-plugin
export var help = "style-module--help--d825e";
export var inner = "style-module--inner--f0d96";
export var main = "style-module--main--80c27";
export var more = "style-module--more--97e02";